import { API_URL, GRAPHQL_URL as GRAPHQL } from "src/constants/env-constants";

export const GRAPHQL_URL = GRAPHQL;
export const USER_PROFILE_API = `${API_URL}/v1/security/my-profile`;
export const V2_RECORD_ID_API = `${API_URL}/api/v1/v2-record-id`;
export const QUEUE_OVERVIEW_API = `${API_URL}/api/v1/queue-overview`;
export const USER_SIGNOUT = `${API_URL}/v1/security/signout`;
